import { useDisplayDayTime } from '@hooks/dates'
import classNames from 'classnames'

export function TimeDisplay({
  className,
  dayClassName,
  timeClassName,
  dateTime,
  timezone,
}: {
  className?: string
  dayClassName?: string
  timeClassName?: string
  dateTime: string
  timezone?: string
}) {
  const {
    day: formattedDay,
    dateSuffix,
    time: formattedTime,
  } = useDisplayDayTime(dateTime, undefined, timezone)

  return (
    <div className={classNames('flex flex-col', className)}>
      <span className={classNames('font-base font-bold', dayClassName)}>
        {formattedDay}
        {dateSuffix}
      </span>
      <span className={classNames('text-sm', timeClassName)}>
        {formattedTime}
      </span>
    </div>
  )
}
